import PeerGroupStepTwo from "../components/PeerGroup/PeerGroupStepTwo";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import { All, KeyValue } from "../interfaces";
export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateUi: (filter: string, value: string | string[] | KeyValue[]) => {
      dispatch(actions.updateUi(filter, value));
      dispatch(actions.searchPush());
    },
    updateFilters: (filter: string, value: string | string[]) => {
      dispatch(actions.updateFilter(filter, value));
      dispatch(actions.searchPush());
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(PeerGroupStepTwo);
